export default __webpack_public_path__ + "static/media/chevron-down.f11eb903.svg";